<template>
  <div class="chead">
    <div class="statusBar"></div>
    <div class="actionBar" :style="{'backgroundColor': theme== 'light' ? '#FFFFFF' : ''}">
      <div :class="theme == 'light' ? 'back-black' : 'back-white' " v-if="visibleBackBtn" @click="back"></div>
      <div class="title" :style="{'color': theme == 'light' ? '#000000' : '#FFFFFF'}">
        <slot></slot>
      </div>
      <div class="right-btn">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import { callNative } from "native-jsbridge";
export default {
  name: "CHeader",
  props: {
    bg: {
      type: String,
      default: "#ffffff",
    },
    isGradient: {
      type: Boolean,
      default: true,
    },
    visibleBackBtn: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'black'
    }
  },
  beforeCreate() {
    document.querySelector('body').classList.add('fullHeight');
    document.querySelector('html').classList.add('fullHeight');
    document.querySelector('#app').classList.add('fullHeight');
  },
  beforeDestroy() {
    document.querySelector('body').classList.remove('fullHeight');
    document.querySelector('html').classList.remove('fullHeight');
    document.querySelector('#app').classList.remove('fullHeight');
  },
  methods:{
    back(){
      callNative({
        method: 'closePage'
      })
    }
  }
};
</script>
<style>
.fullHeight {
  height: 100%;
}
</style>
<style lang="less" scoped>
.chead {
  width: 100%;
  display: flex;
  .statusBar {
    height: 0.53rem;
  }
  .actionBar {
    height: 1.18rem;
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: left;
    align-items: center;
    .back-white {
      background-image: url('../assets/imgs/my/back.png');
      width: 1.18rem;
      height: 1.18rem;
      background-size: contain;
      position: absolute;
    }
    .back-black {
      background-image: url('../assets/imgs/my/black_back.png');
      width: 1.18rem;
      height: 1.18rem;
      background-size: contain;
      position: absolute;
    }
    .title {
      height: 1.18rem;
      font-size: 0.48rem;
      line-height: 1.18rem;
      text-align: center;
      width: 100%;
    }
    .right-btn {
      position: absolute;
      font-size: 0.37rem;
      font-weight: 400;
      right: 0rem;
      margin-right: 0.4rem;
    }
  }
}
</style>